import { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import Print from "@arcgis/core/widgets/Print.js";
import esriConfig from "@arcgis/core/config.js";

//const Tool_1_PanelComponent = ({ mapView }) => {
const ExportComponent = forwardRef(({ mapView }, ref) => {

    const widgetPrint = useRef(null);


    const [mapClickHandler, setMapClickHandler] = useState();

    const componentMapClick = (event) => {
        //console.log("Tool_1_PanelComponent mapView click event", event);
        //alert("Click over map with ExportComponent")
    };

    useImperativeHandle(ref, () => ({
        parentOpened() {
            let handler = mapView.on("click", componentMapClick);
            setMapClickHandler(handler);
        },
        parentClosed() {
            mapClickHandler.remove();
        }
    }));

    useEffect(() => {
        console.log("widgetPrint.current", widgetPrint.current);

        let printServiceUrl = "https://aplicaciones.sgv.es/arcgis/rest/services/iaa/ExportWebMap/GPServer/Export%20Web%20Map";
        let printServiceUrlIntercept = "https://aplicaciones.sgv.es/arcgis/rest/services/iaa/ExportWebMap";

        esriConfig.request.interceptors.push({
            urls: printServiceUrlIntercept,
            headers: function (params) {
                console.log("headers params", params);
            },
            before: function (params) {
                console.log("before params", params);
                //params.requestOptions.headers["X-Esri-Authorization"] = "Bearer " + localStorage.getItem("token");
                //Access-Control-Allow-Origin http://localhost:3000
            },
            after: function (response) {
                console.log("after response", response);
            }
        });


        if (widgetPrint.current.innerHTML !== "") {
            widgetPrint.current.removeChild(widgetPrint.current.children[0])
        }

        const print = new Print({
            view: mapView,
            // specify your own print service
            printServiceUrl: printServiceUrl,

            //"https://aplicaciones.sgv.es/arcgis/rest/services/iaa/ExportWebMapV2/GPServer/Exportar%20mapa%20Web",
            //"https://aplicaciones.sgv.es/arcgis/rest/services/iaa/ExportWebMapV2/GPServer/Export%20Web%20Map",
            //"https://aplicaciones.sgv.es/arcgis/rest/services/ayto_siarq/ExportWebMap_v02/GPServer/Export%20Web%20Map",
            container: widgetPrint.current
        });


        console.log("print", print);
    }, [])

    return (
        <>
            <div ref={widgetPrint} id="AAAAAAAAAAAAAAAAA"></div>
        </>
    )
});
export default ExportComponent;